export const ROBBERY_LIST = 'ROBBERY_LIST';
export const TOGGLE_SIDE_BAR_T009 = 'TOGGLE_SIDE_BAR/T009';
export const ADD_ROBBERY = 'ADD_ROBBERY';
export const UPDATE_ROBBERY = 'UPDATE_ROBBERY';
export const DELETE_ROBBERY = 'DELETE_ROBBERY';
export const UPDATE_ROBBERY_SELECTED_IDS = 'UPDATE_SELECTED_IDS';
export const UPDATE_SELECTED_IDS = 'UPDATE_SELECTED_IDS';
export const ROBBERY_LOADER = 'ROBBERY_LOADER';
